export enum ProvidersSlugEnum {
  PRESSABLE = 'pressable',
  NESTIFY = 'nestify',
}
